let converterPromise;

export default function heic2any(options)
{
    if (typeof window === 'undefined'
        || typeof URL === 'undefined'
        || typeof URL.createObjectURL !== 'function'
        || typeof Blob !== 'function'
        || typeof Worker !== 'function')
    {
        return Promise.reject(new Error('HEIC conversion is unavailable.'));
    }

    if (!converterPromise)
    {
        // Keep the library bundled, but defer its worker initialization until needed.
        // Cache failures too: retrying a partially initialized module is unsafe.
        converterPromise = Promise.resolve().then(() => require('heic2any'));
    }

    return converterPromise.then(converter => converter(options));
}
